import App from "./App.svelte";
import { staticUrl } from "./static";
import { lang } from "./i18n";

const EXAMPLE_API_CALL = `curieuzenair.init({ container: 'map-root', staticUrl: 'https://static.curieuzenair.be/', lang: 'nl', legendLink: 'https://www.curieuzenair.be/' })`;

function init(options) {
  if (!options) {
    console.error(`Please specify options, e.g. ${EXAMPLE_API_CALL}`);
    return;
  }
  if (!options.container) {
    console.error(`Please specify options.container, e.g. ${EXAMPLE_API_CALL}`);
    return;
  }
  if (!options.staticUrl) {
    console.error(`Please specify options.staticUrl, e.g. ${EXAMPLE_API_CALL}`);
    return;
  }
  if (!options.staticUrl.endsWith("/")) {
    console.error(`Make sure options.staticUrl ends with a trailing slash, e.g. ${EXAMPLE_API_CALL}`);
    return;
  }
  staticUrl.set(options.staticUrl);
  if (!options.lang) {
    console.warn(`Please specify a default language using options.lang, e.g. ${EXAMPLE_API_CALL}`);
    options.lang = "nl";
  }
  lang.set(options.lang);

  const container = document.getElementById(options.container);
  if (!container) {
    console.error(`Could not find container with id ${options.container}`);
    return;
  }

  let welcomePopupVisible = typeof options.welcomePopupVisible === "boolean" ? options.welcomePopupVisible : true;

  if (!options.legendLink) {
    console.warn(`Please specify a link for the legend using options.legendLink, e.g. ${EXAMPLE_API_CALL}`);
    options.legendLink = "https://www.standaard.be/tag/curieuzenair-bxl";
  }
  // if (document.location.hash.length > 0) {
  //   welcomePopupVisible = false;
  // }

  const handleSetLanguage = (newLanguage) => {
    lang.set(newLanguage);
  };

  const app = new App({
    target: container,
    props: { welcomePopupVisible, legendLink: options.legendLink },
  });

  return { setLanguage: handleSetLanguage, app };
}

export default { init };
